<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>绑卡短信验证</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS7313</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>快捷：kj</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>固定：1</td></tr>
          <tr><td>用户编号</td><td>buyerCd</td><td>String(64)</td><td>是</td><td>业务系统用户id</td></tr>
          <tr><td>绑卡令牌</td><td>adddata1</td><td>String(32)</td><td>是</td><td></td></tr>
          <tr><td>短信验证码</td><td>vercode</td><td>String(10)</td><td>是</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>平台流水号</td><td>orderCd</td><td>String(20)</td><td>否</td><td>平台返回的交易流水号</td></tr>
          <tr><td>绑卡协议编号</td><td>chnlCardCd</td><td>String(32)</td><td>是</td><td>绑卡协议编号</td></tr>
          <tr><td>绑卡支付编号</td><td>adddata1</td><td>String(32)</td><td>否</td><td>绑卡支付编码，新生通道支付下单需要上送该字段</td></tr>
          <tr><td>绑卡状态</td><td>transStatus</td><td>String(3)</td><td>是</td><td>100成功，101绑卡中，102绑卡失败</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [{'url': '/interface/kj/kjkys', 'name': '快捷卡要素支付'},
        {'url': '/interface/kj/kjbk', 'name': '快捷绑卡'},
        {'url': '/interface/kj/kjbkyz', 'name': '快捷绑卡短信验证'},
        {'url': '/interface/kj/kjxd', 'name': '快捷下单'},
        {'url': '/interface/kj/kjxdyz', 'name': '快捷下单短信验证'},
        {'url': '/interface/kj/kjjb', 'name': '解绑'},
        {'url': '/interface/kj/yjkj', 'name': '一键快捷'},
        {'url': '/interface/kj/ddzz', 'name': '订单转账'},
        {'url': '/interface/tk', 'name': '退款'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/ybtz', 'name': '异步通知'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/kj/kjbkyz.vue